import {isArray, isString, isProdEnv} from './Utils'

export default class StorageUtils {
    static USER_KEY = 'USER_KEY';
    static ACCESS_TOKEN = 'ACCESS_TOKEN';
    static CACHE_USER = null;

    static put(key, val) {
        localStorage.setItem(key, val);
    }

    static get(key) {
        return localStorage.getItem(key)
    }

    static destroy(key) {
        localStorage.removeItem(key)
    }

    static getUser() {
        if (this.CACHE_USER) return this.CACHE_USER;
        this.CACHE_USER = JSON.parse(this.get(this.USER_KEY));
        return this.CACHE_USER;
    }

    static saveUser(user) {
        this.CACHE_USER = user;
        this.put(this.USER_KEY, JSON.stringify(user));
    }

    static destroyUser() {
        this.CACHE_USER = null;
        this.destroy(this.USER_KEY);
    }

    // Consentimento do assistente de IA (docs/mcp/16b-tempo-real.md), opt-in.
    static assistantSharesScreen() {
        return this.get('assistant_share_screen') === 'true';
    }

    static setAssistantSharesScreen(on) {
        this.put('assistant_share_screen', on ? 'true' : 'false');
    }

    static assistantCanNavigate() {
        return this.get('assistant_can_navigate') === 'true';
    }

    static setAssistantCanNavigate(on) {
        this.put('assistant_can_navigate', on ? 'true' : 'false');
    }

    static getAuthToken() {
        let name = this.ACCESS_TOKEN + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1);

            if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
        }

        return null;
    }

    static userIsProfile(profile) {
        const user = this.getUser();

        if (isString(profile)) return user && user.profile === profile;
        else if (isArray(profile)) {
            return profile.filter(p => p === user.profile).length > 0;
        }
    }

    static saveAuthToken(token) {
        const d = new Date();
        d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
        const domain = document.location.hostname;
        const arr = [`${this.ACCESS_TOKEN}=${token}`];

        if (isProdEnv()) arr.push('; secure');

        const expires = "; expires=" + d.toUTCString();
        arr.push(expires, `; domain=${domain}`, '; path=/;');

        document.cookie = arr.join('')
    }

    static destroyAuthToken() {
        const domain = document.location.hostname;
        const arr = [`${this.ACCESS_TOKEN}=`];
        if (isProdEnv()) arr.push('; secure');
        arr.push(`; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=/;`);

        document.cookie = arr.join('');
    }

    static saveObject(key, obj) {
        this.put(key, JSON.stringify(obj))
    }

    static getObject(key) {
        return JSON.parse(this.get(key))
    }
}
